module.exports = "<div class=\"treatment-cell no-data\">\r\n    {{#HasFullText}}\r\n        <p>This document has not yet been classified against our legal taxonomy.</p>\r\n    {{/HasFullText}}\r\n    {{^HasFullText}}\r\n        <p>There is no Judgment available for this case, therefore we are unable to provide categories.</p>\r\n    {{/HasFullText}} \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/partials/no-categories.html
// module id = 349
// module chunks = 1